// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"ad19a806","453":"54292a4b","477":"fe71d3f7"}[chunkId] + ".chunk.js";
};